
import { soldOut, noPickupTime, isChecked, fen2Yuan, getNumber, getSmallNumber } from "./js/common.js"
export default {
  name: "BestOffer",
  props: {
    item: {
      type: Object,
      default: () => {}
    },
    unRange: {
      type: Boolean,
      default: false
    },
    slaveStore: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {}
  },
  computed: {
    promotionInfo() {
      const promotionList = this.item.promotionList || []
      return promotionList[0] || {}
    },
    wares() {
      return this.item.wareList || []
    }
  },
  methods: {
    soldOut,
    noPickupTime,
    isChecked,
    fen2Yuan,
    getNumber,
    getSmallNumber,
    toggleWareSelect() {
      if (this.unRange) return

      this.$emit("toggleWareSelect", {
        items: this.wares,
        bestOffer: true,
        promotionInfo: this.promotionInfo
      })
    },
    handleWareDelete(item) {
      if (this.unRange) return

      this.$emit("handleWareDelete", item)
    },
    addMore() {
      if (this.unRange) return

      const fristItem = (this.item.bestOfferWareCountList && this.item.bestOfferWareCountList[0]) || {}
      console.log("addMore==>", this.promotionInfo)
      this.$emit("addMore", this.promotionInfo, "multiple", fristItem.skuId)
    },
    toProductDetail(item) {
      if (this.slaveStore) return
      this.$navigation.push({
        path: `${this.MAIN_PATH}/p/${encodeURIComponent(item.wareName)}/i/${item.skuId}.html`
      })
    }
  }
}
